var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-content-placeholder',{attrs:{"icon":"check","icon-color":"success","prompt-text":"Complete"},scopedSlots:_vm._u([{key:"message",fn:function(){return [_vm._v("All conflicts have been resolved.")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }